import React from "react";

const Banner = () => {
  return (
    <div className="mt-5 container banner d-flex flex-column justify-content-center align-items-center">
      {/* <h1>Doje</h1>
      <p>C’est bien ou c’est pas bien ?</p> */}
      <button type="button" class="btn btn-dark primaryBtn rounded-pill px-3">
        What is Doje?
      </button>
    </div>
  );
};

export default Banner;
